// src/components/Header.js

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import PopupModal from "./PopupModal";

import {
    userMe,
    userLogout
} from "../config/userApi";


function Header() {

    /*
    |--------------------------------------------------------------------------
    | Navigation
    |--------------------------------------------------------------------------
    */

    const navigate = useNavigate();


    /*
    |--------------------------------------------------------------------------
    | Popup State
    |--------------------------------------------------------------------------
    */

    const [showPopup, setShowPopup] = useState(false);


    /*
    |--------------------------------------------------------------------------
    | Logged User
    |--------------------------------------------------------------------------
    */

    const [user, setUser] = useState(null);

    const [loadingUser, setLoadingUser] = useState(true);


    /*
    |--------------------------------------------------------------------------
    | Check User Login
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const checkUser = async () => {

            try {

                console.log(
                    "Checking logged-in user..."
                );


                const response = await userMe();


                console.log(
                    "User Me Status:",
                    response.status
                );


                /*
                |--------------------------------------------------------------------------
                | User Logged In
                |--------------------------------------------------------------------------
                */

                if (response.ok) {

                    const data = await response.json();


                    console.log(
                        "Logged User Response:",
                        data
                    );


                    if (
                        data.success &&
                        data.user
                    ) {

                        console.log(
                            "✅ User Logged In:"
                        );

                        console.log(
                            data.user
                        );


                        setUser(
                            data.user
                        );

                    } else {

                        setUser(null);

                    }

                }


                /*
                |--------------------------------------------------------------------------
                | User Not Logged In
                |--------------------------------------------------------------------------
                */

                else {

                    console.log(
                        "❌ User Not Logged In"
                    );


                    setUser(null);

                }

            } catch (error) {

                console.error(
                    "User Authentication Error:",
                    error
                );


                setUser(null);

            } finally {

                setLoadingUser(false);

            }

        };


        checkUser();

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Logout
    |--------------------------------------------------------------------------
    */

    const handleLogout = async () => {

        try {

            console.log(
                "Logging out user..."
            );


            const response = await userLogout();


            console.log(
                "Logout Status:",
                response.status
            );


            /*
            |--------------------------------------------------------------------------
            | Read Response
            |--------------------------------------------------------------------------
            */

            const responseText =
                await response.text();


            console.log(
                "Raw Logout Response:",
                responseText
            );


            let data = {};


            try {

                if (responseText) {

                    data =
                        JSON.parse(
                            responseText
                        );

                }

            } catch (jsonError) {

                console.error(
                    "Logout JSON Parse Error:",
                    jsonError
                );

            }


            console.log(
                "Logout Response:",
                data
            );


            /*
            |--------------------------------------------------------------------------
            | Logout Successful
            |--------------------------------------------------------------------------
            */

            if (response.ok) {

                console.log(
                    "✅ User Logged Out Successfully"
                );


                /*
                |--------------------------------------------------------------------------
                | Clear User
                |--------------------------------------------------------------------------
                */

                setUser(null);


                /*
                |--------------------------------------------------------------------------
                | Close Popup
                |--------------------------------------------------------------------------
                */

                setShowPopup(false);


                /*
                |--------------------------------------------------------------------------
                | Success Message
                |--------------------------------------------------------------------------
                */

                await Swal.fire({

                    icon: "success",

                    title: "Logged Out",

                    text:
                        "You have been logged out successfully.",

                    timer: 1200,

                    showConfirmButton: false

                });


                /*
                |--------------------------------------------------------------------------
                | Redirect To Home
                |--------------------------------------------------------------------------
                */

                navigate("/");


                return;

            }


            /*
            |--------------------------------------------------------------------------
            | Logout Failed
            |--------------------------------------------------------------------------
            */

            console.error(
                "Logout Failed:",
                data.message
            );


            Swal.fire({

                icon: "error",

                title: "Logout Failed",

                text:
                    data.message ||
                    "Unable to logout. Please try again."

            });

        } catch (error) {

            console.error(
                "Logout Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Connection Error",

                text:
                    error.message ||
                    "Unable to connect with server."

            });

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Header
    |--------------------------------------------------------------------------
    */

    return (

        <>

            <nav className="navbar navbar-expand-lg">

                <div className="container">


                    {/* -------------------------------------------------
                        LOGO
                    -------------------------------------------------- */}

                    <div className="d-flex align-items-center gap-2">

                        <div>

                            <img
                                src="assets/logo.png"
                                alt="HomeoAdda Logo"
                                className="header-logo"
                            />

                        </div>

                    </div>


                    {/* -------------------------------------------------
                        MOBILE MENU BUTTON
                    -------------------------------------------------- */}

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >

                        <span className="navbar-toggler-icon"></span>

                    </button>


                    {/* -------------------------------------------------
                        MENU
                    -------------------------------------------------- */}

                    <div
                        className="collapse navbar-collapse justify-content-end"
                        id="navbarNav"
                    >

                        <ul className="navbar-nav align-items-lg-center gap-lg-4">


                            {/* -------------------------------------------------
                                Subjects
                            -------------------------------------------------- */}

                            {/* <li className="nav-item dropdown">

                                <span
                                    className="nav-link dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    style={{
                                        cursor: "pointer"
                                    }}
                                >

                                    Subjects

                                </span>


                                <ul className="dropdown-menu">

                                    <li>

                                        <a
                                            className="dropdown-item"
                                            href="#"
                                        >
                                            Anatomy
                                        </a>

                                    </li>


                                    <li>

                                        <a
                                            className="dropdown-item"
                                            href="#"
                                        >
                                            Physiology
                                        </a>

                                    </li>


                                    <li>

                                        <a
                                            className="dropdown-item"
                                            href="#"
                                        >
                                            Biochemistry
                                        </a>

                                    </li>


                                    <li>

                                        <a
                                            className="dropdown-item"
                                            href="#"
                                        >
                                            Pathology
                                        </a>

                                    </li>


                                    <li>

                                        <a
                                            className="dropdown-item"
                                            href="#"
                                        >
                                            Pharmacology
                                        </a>

                                    </li>

                                </ul>

                            </li> */}


                            {/* -------------------------------------------------
                                Home
                            -------------------------------------------------- */}

                            <li className="nav-item">

                                <Link
                                    className="nav-link"
                                    to="/"
                                >
                                    Home
                                </Link>

                            </li>


                            {/* -------------------------------------------------
                                About
                            -------------------------------------------------- */}

                                <li className="nav-item">

                                <Link
                                    className="nav-link"
                                    to="/about-us"
                                >
                                    About
                                </Link>

                                </li>

                                <li className="nav-item">

                                    <Link
                                        className="nav-link"
                                        to="/jobs"
                                    >
                                        Jobs & Careers
                                    </Link>

                                </li>

                                <li className="nav-item">

                                    <Link
                                        className="nav-link"
                                        to="/study-material"
                                    >
                                        Study Material
                                    </Link>

                                </li>


                            {/* -------------------------------------------------
                                Contact
                            -------------------------------------------------- */}

                            <li className="nav-item">

                                <Link
                                    className="nav-link"
                                    to="/Contact"
                                >
                                    Contact
                                </Link>

                            </li>


                            {/* -------------------------------------------------
                                USER LOGIN / DASHBOARD / WELCOME
                            -------------------------------------------------- */}

                            <li className="nav-item">


                                {/* -------------------------------------------------
                                    Loading
                                -------------------------------------------------- */}

                                {loadingUser ? (

                                    <span className="nav-link ms-lg-3">

                                        Checking...

                                    </span>

                                ) : user ? (


                                    /* -------------------------------------------------
                                       USER LOGGED IN
                                    -------------------------------------------------- */

                                    <div className="d-flex align-items-center gap-2 ms-lg-3">


                                        {/* -------------------------------------------------
                                            Dashboard Button
                                        -------------------------------------------------- */}

                                       


                                        {/* -------------------------------------------------
                                            Welcome Dropdown
                                        -------------------------------------------------- */}

                                        <div className="dropdown">

                                            <button
                                                className="btn btn-login dropdown-toggle"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >

                                                Welcome,{" "}

                                                <strong>
                                                    {user.fullname}
                                                </strong>

                                            </button>


                                            <ul className="dropdown-menu dropdown-menu-end">


                                                {/* -------------------------------------------------
                                                    Dashboard
                                                -------------------------------------------------- */}

                                                <li>

                                                    <Link
                                                        to="/dashboard"
                                                        className="dropdown-item"
                                                    >

                                                        Dashboard

                                                    </Link>

                                                </li>


                                                {/* -------------------------------------------------
                                                    Divider
                                                -------------------------------------------------- */}

                                                <li>

                                                    <hr className="dropdown-divider" />

                                                </li>


                                                {/* -------------------------------------------------
                                                    Logout
                                                -------------------------------------------------- */}

                                                <li>

                                                    <button
                                                        type="button"
                                                        className="dropdown-item text-danger"
                                                        onClick={handleLogout}
                                                    >

                                                        Logout

                                                    </button>

                                                </li>


                                            </ul>

                                        </div>

                                    </div>


                                ) : (


                                    /* -------------------------------------------------
                                       USER NOT LOGGED IN
                                    -------------------------------------------------- */

                                    <button
                                        type="button"
                                        className="btn btn-login ms-lg-3"
                                        onClick={() =>
                                            navigate("/Login")
                                        }
                                    >

                                        Login / Signin

                                    </button>

                                )}

                            </li>


                        </ul>

                    </div>

                </div>

            </nav>


            {/* ---------------------------------------------------------
                POPUP MODAL
            ---------------------------------------------------------- */}

            <PopupModal
                show={showPopup}
                onClose={() =>
                    setShowPopup(false)
                }
            />

        </>

    );

}


export default Header;